<template>
  <TransitionRoot as="template" :show="open">
    <Dialog
        as="div" static class="fixed z-10 inset-0 overflow-y-auto" @close="$emit('modal:cancel')" :open="open">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
        <div
            :class="width"
            class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle  sm:p-6">
          <div>
<!--                <CheckIcon class="h-6 w-6 text-green-600" aria-hidden="true" />-->
            <slot name="icon" >
              <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                <CheckIcon class="text-green-600" />
              </div>

            </slot>
            <div class="mt-3 text-center sm:mt-5">
              <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
              <slot name="title" ></slot>
              </DialogTitle>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                 <slot name="content" ></slot>
                </p>
              </div>
            </div>
          </div>
          <div :class="getButtonGrid()" class="mt-5 sm:mt-6 sm:grid sm:gap-3 sm:grid-flow-row-dense">
            <slot name="actionButton"></slot>

            <slot name="cancelButton"></slot>

          </div>
        </div>
      </TransitionChild>
    </div>
  </Dialog>
</TransitionRoot>
</template>

<script>
import { ref } from 'vue'
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { CheckIcon } from '@heroicons/vue/outline'
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";
import DangerButton from "@/components/Functional/Buttons/DangerButton";
import NeutralButton from "@/components/Functional/Buttons/NeutralButton";
export default {
  name: "GravyModal",
  components: {
    NeutralButton,
    DangerButton,
    PrimaryButton,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    CheckIcon,
  },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    titleText: {},
    contentText: {},
    icon: {},
    width: {
      type: String,
      default: 'w-lg'
    }
  },
  methods: {
    getButtonGrid() {
      return this.$slots.cancelButton ? 'grid-cols-2' : 'grid-cols-1'
    }
  },
  emits: ['modal:cancel', 'modal:perform']
  // data() {
  //   return {
  //     open: false
  //   }
  // }
}
</script>

<style scoped>

</style>